import { render, staticRenderFns } from "./fk-select.vue?vue&type=template&id=0869e249&"
import script from "./fk-select.vue?vue&type=script&lang=js&"
export * from "./fk-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports